/**
 * The three BIO-PLY™ feature cards — the single source of truth for the
 * "what it does" trio that appears in two places:
 *
 *   1. The home page Features section (`#features` on the marketing home).
 *   2. The brand panel beside the sign-in form.
 *
 * The two used to carry separate copies of this copy, so a wording change had
 * to be made twice. Edit the entries here and both surfaces update together.
 *
 * `icon` is a Material Symbols name (see components/ui/Icon). Order matters:
 * both surfaces render the list top to bottom as written.
 */
export const BIO_PLY_FEATURES = [
  {
    icon: 'shield',
    title: 'Stops the infection',
    body: 'Direct antibacterial activity against bacteria, including biofilms commonly found in septic joints.',
  },
  {
    icon: 'water_drop',
    title: 'Protects the joint',
    body: 'Helps reduce destructive inflammation while supporting cartilage and synovial health.',
  },
  {
    icon: 'auto_fix_high',
    title: 'Supports recovery',
    body: 'Promotes restoration of healthy joint tissues during healing.',
  },
];

export default BIO_PLY_FEATURES;
